// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2ryZD","name":"ConsentHeader_name__5D--j","birthday":"ConsentHeader_birthday__3DO2z","skeleton":"ConsentHeader_skeleton__xjSUX"};